// extracted by mini-css-extract-plugin
export default {"pic_box":"index_pic_box_9bSil","picMark":"index_picMark_8V7ek"};